import React, {useEffect,useState
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { useDispatch, useSelector } from "react-redux"
import { Table, Tag, Space } from 'antd';
import { Select } from 'antd';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import * as XLSX from 'xlsx';
import Cookie from 'js-cookie';
import { getStoreList, isEdit, getSelectedStoreList,CretateStore ,ShowStoreDetail} from './actions/storeService';
import EditStore from './EditStore';
import AddStore from './AddStore';
import StoreView from './StoreView';
import LZString from 'lz-string';

const { Option } = Select;






const Stores= () =>{

  const [searchedItem, setSearchedItem] = useState({
    storeName:[],
  });
  const  storeList = useSelector(state => state?.store?.StoreDetails?.Stores)
  const  AllowStores = useSelector(state => state?.store?.StoreDetails?.AllowStores[0])
  console.log(AllowStores,'AllowStores')
  const status = useSelector(state => state?.store)
  const dispatch = useDispatch()
  const config = JSON.parse(Config);
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData) 
  let userID = user['userId'];
  const title='Stores';
  const apiInterface = config['api1']
  const TableColumns= [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i className="fa fa-eye orange" aria-hidden="true" onClick={() => _doNavToViewStore(text, record)}></i>
            {AllowStores?.allow_edit == 1 &&<i className="fa fa-pencil blue" aria-hidden="true" onClick={() => _doNavToEditStore(text, record)}></i>}
          </div>
        </Space>
      ),
    },
    {
      title: "Cost Center",
      dataIndex: "CostCenter",
      key: "CostCenter"
    },
    {
      title: "Store Name",
      dataIndex: "StoreName",
      key: "StoreName"
    },
    {
      title: "City",
      dataIndex: "City",
      key: "City"
    },
    {
      title: "Zone",
      dataIndex: "ZoneName",
      key: "ZoneName"
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status"
    },
  ];
  const [tableData, setTableData] = useState([])
  // TableData= storeList;
  // const  loading= false;
  const  message= '';
  const modalOpen= false;

  const _doNavToAddStore = () => {
    dispatch(CretateStore(true));
    // navigate("/AddStore");
  };
  const _doNavToEditStore = (text, record) => {
    dispatch(getSelectedStoreList(record));
    dispatch(isEdit(true));
    // navigate("/EditStore");
  };
  const _doNavToViewStore = (text, record) => {
    Cookie.set('storeId', record.storeId)
    dispatch(getSelectedStoreList(record))
    dispatch(ShowStoreDetail(true));
  };
  const _doSelectStore = (value)=>{
    // setSearchedStore([...searchedStore ,searchedStore=value]);
    setSearchedItem({
      ...searchedItem,
      storeName: value,
    });

  }
  const handleSearch = () =>{
    // setTableData(storeList.filter(ele=>ele.storeId==searchedStore))
      if(searchedItem.storeName.length !=0){
        let data = []
        for(let i =0;i<searchedItem.storeName.length;i++){
          let fetchedData = storeList.filter(ele=> ele.StoreName == searchedItem.storeName[i]).map(element=>data.push(element))
        }
        setTableData(data)
      }else{
        setTableData(storeList);
      }
  }
  useEffect(() => {
    dispatch(getStoreList(userID, '100'));
    
  }, [])
  useEffect(() => {
    if(searchedItem.storeName.length!=0){
      handleSearch()
    }else{
      setTableData(storeList)
    }
  }, [storeList])

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const wsData = [
      [
        'Store Name', 'Cost Center', 'Zone Name', 'State Name', 'City', 'GST Number', 'Building Type',
        'Property Type', 'Store Type', 'Store Address', 'Total Build Area', 'Total Sales Area', 'Car Parking',
        'Number Of Car Parking', 'Number Of Two Wheeler Parking', 'Number Of Stack Parking', 'PlayGround Concrete',
        'PlayGroung Size', 'PlayGround Turf', 'PlayGround Turf Size', 'Store Opening Date', 'Lease Start Date',
        'Lease End Date', 'Warranty Date', 'LandLord Name', 'LandLord Email', 'LandLord Contact Number',
        'LandLord Alternative Number', 'Store Operation Referent Email', 'Store Operation Referent Number',
        'Store Operation Referent Name', 'Store Manager Email', 'Store Manager Name', 'Store Manager Number',
        'ZOM Coach Email', 'Zone Operation Maintaince Coach Name', 'Zone Operation Maintaince Coach Number',
        'Construction Manager Email', 'Construction Manager Name', 'Construction Manager Mobile Number',
        'Maintaince Leader Email', 'Maintaince Leader Name', 'Maintaince Leader Number', 'Status'
      ],
      ...tableData.map(row => [
        row.StoreName, row.CostCenter, row.ZoneName, row.StateName, row.City, row.GstNumber, row.BuildingType_name,
        row.Property_type_name, row.StoreType, row.StoreAddress, row.TotalBuitlArea, row.TotalSalesArea, row.CarParking,
        row.NumberOfCarParking, row.NumberOfTwoWheelerParking, row.NumberOfStackParking, row.PlayGroundConcrete,
        row.PlayGroungSize, row.PlayGroundTurf, row.PlayGroundTurfSize, row.StoreOpeningDate, row.LeaseStartDate,
        row.LeaseEndDate, row.WarrantyDate, row.LandLordName, row.LandLordEmail, row.LandLordContactNumber,
        row.LandLordAltNumber, row.SOREmail, row.StoreOpReferentNumber, row.StoreOpRefName, row.StoreManagerEmail, // Corrected here
        row.StoreManagerName, row.StoreManagerNumber, row.ZOMCoachEmail, row.ZoneOpMCoachName, row.ZoneOpCoachNumber,
        row.CMEmail, row.ConstructionManagerName, row.ConstructionManagerMobileNumber, // Corrected here
        row.MaintenanceLeaderEmail, row.MaintenanceLeaderName, row.MaintenanceLeaderNumber, row.Status // Corrected here
      ])
    ];
    
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, title + '.xlsx');
    XLSX.writeFile(wb, title + '.xlsx');
  };
    return (
      <>
        {status.isStoreList ? <div>
          {modalOpen ? (
            <MessageBox
              message={message}
              signout={false}
              // onClose={handleClose}
            />
          ) : null}

          <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            <div className='content-wrapper'>
              {status?.loading ? (
                <Spinner />
              ) : (
                <div>
                  {AllowStores?.add_allow == 1 && <div className="m-btn-block">
                    <div className="m-btn-block__container">
                      <div className="m-btn-block__icon">
                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                      </div>
                      <div className="m-btn-block__btns">
                        <button type='submit' onClick={_doNavToAddStore} className='btn btn-secondary deca-btn-yellow'>Create New Store</button>
                      </div>
                    </div>
                  </div>}
                  <section className='content'>
                    {/* <div className="m-page__button">
              <button type='submit' onClick={_doNavToAddStore} className='btn btn-secondary deca-btn-yellow'>Create New Store</button>
            </div> */}
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="row">
                          <div className="col-md-3">
                            <div className='form-group select_h150'>
                              <label htmlFor='exampleInput'>Select Store</label>
                              
                              <Select className="form-control"
                                showSearch
                                mode="multiple"
                                onChange={_doSelectStore}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                value={searchedItem.storeName}
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                storeList?.map((item =>
                                    <Option key={item.storeId} value={item.StoreName}>{item.StoreName}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleSearch}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                          <div className="col-md-3 btn-no-lbl">
                            {/* <button type='submit' className='btn btn-secondary deca-btn-yellow'>
                            Download Excel
                          </button> */}
                          <button className='btn btn-secondary deca-btn-yellow' onClick={exportToExcel}>
                            Export to Excel
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="m-table__main">
                          <div className="m-table__responsive medium-width">
                            <Table filterSearch="true" columns={TableColumns} dataSource={tableData} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              )}
            </div>
            <Footer />
          </div>
        </div> : null}
        {
          status?.isStoreEdit ? <EditStore /> : null
        }
        {
          status?.isStoreCreate ? <AddStore /> : null
        }
         {
          status?.isStoreView ? <StoreView /> : null
        }
      </>
    )

}
export default Stores;